import { format } from "date-fns";
import axiosInstance from "../config/AuthInterceptors";
import { IBeehiveStats, IBeehiveStatsGenericResponse, IBeehiveStatsGetListResponse, IExportStat } from "../interfaces/beehiveStats";
import utilsService from "./utilsService";

const BASE_URL = process.env.REACT_APP_API_URL

const beehiveStatsService = {
    getAll: (
        beehiveId: string,
        source: "manual" | "import" = "manual",
        skip: number = 0,
        limit: number = 25,
    ) => axiosInstance.get<IBeehiveStatsGetListResponse>("/beehouses/" + beehiveId + "/stats", {
        params: {
            source,
            skip,
            limit
        }
    }).then(res => res.data),
    getAllForCharts: (
        beehiveId: string,
        from: string,
        to: string
    ) => axiosInstance.get<IBeehiveStatsGetListResponse>("/beehouses/" + beehiveId + "/stats", {
        params: {
            from,
            to
        }
    }).then(res => res.data),
    get: (beehiveId: string, id: string) => axiosInstance.get<IBeehiveStatsGenericResponse>("/beehouses/" + beehiveId + "/stats/" + id).then(res => res.data),
    post: (beehiveId: string, body: Partial<IBeehiveStats>) => axiosInstance.post<IBeehiveStatsGenericResponse>("/beehouses/" + beehiveId + "/stats", body).then(res => res.data),
    put: (beehiveId: string, id: string, body: Partial<IBeehiveStats>) => axiosInstance.put<IBeehiveStatsGenericResponse>("/beehouses/" + beehiveId + "/stats/" + id, body).then(res => res.data),
    delete: (beehiveId: string, id: string) => axiosInstance.delete<IBeehiveStatsGenericResponse>("/beehouses/" + beehiveId + "/stats/" + id).then(res => res.data),
    downloadCSV: (beehiveId: string, source: "manual" | "import", params?: IExportStat) => {
        let fieldsToExport: string[] = []
        let url = '';

        if (params) {
            Object.keys(params).forEach(
                key => {
                    if (typeof params[key as keyof IExportStat] === "boolean" && params[key as keyof IExportStat] === true) {
                        fieldsToExport.push("&fieldsToExport=" + key.slice(0, 1).toUpperCase() + key.slice(1))
                    }
                }
            )

            const fields = fieldsToExport.length > 0 ? fieldsToExport.join("") : undefined

            url = `${BASE_URL}/beehouses/${beehiveId}/stats?limit=1000000&source=${source}&exportAs=csv&from=${format(params.from, "yyyy-MM-dd HH:mm")}&to=${format(params.to, "yyyy-MM-dd HH:mm")}${fields}`;
        } else {
            url = `${BASE_URL}/beehouses/${beehiveId}/stats?limit=1000000&source=${source}&exportAs=csv`;
        }

        utilsService.downloadFileFromMemory(url);
    }
}

export default beehiveStatsService;